import React, { useEffect, useContext } from 'react';
import { AnalyticsContext } from '../../ModularReduxAnalytics';

import Layout from '../../components/Layout/Layout';
import css from './NeedParent.module.scss';

const NeedParent = props => {
  const { analytics } = useContext(AnalyticsContext);

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.trackEvent('Registration Under 13 Viewed');
  }, []);

  return (
    <Layout>
      <div className={css.NeedParentMainBox} data-e2e="need-adult">
        <h1 data-e2e="need-adult-header">
          You’ll need a parent to create your account
        </h1>
        <p data-e2e="need-adult-legal">
          Please tell your parent or guardian about Greenlight and have them
          sign up at{' '}
          <a data-testid="need-adult-link" href={`https://greenlight.com/`}>
            greenlight.com
          </a>{' '}
          or download on the app store.
        </p>
      </div>
    </Layout>
  );
};

export default NeedParent;
